import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CITIES } from "@/data/cities";

export default function Footer() {
  const location = useLocation();

  const handleHomeClick = (e: React.MouseEvent) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.location.reload();
    }
  };

  return (
    <footer className="bg-brand-gray-dark text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="text-center md:text-left">
            <Link to="/" onClick={handleHomeClick}>
              <img
                src="https://cdn.builder.io/api/v1/image/assets%2F2651dca913d34eafa320b193e1b2c34e%2F8121edc6d36948818bfb782ce0bc625a?format=webp&width=800"
                alt="Specialized Services"
                className="h-48 md:h-40 mb-4 mx-auto md:mx-0"
              />
            </Link>
            <p className="text-gray-300 text-sm">
              Top Rated Kitchen & Bathroom Remodeling in Orange County, CA since
              1992.
            </p>
          </div>

          <div className="text-center md:text-left">
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-gray-300 flex flex-col items-center md:items-start">
              <li>
                <Link
                  to="/kitchen-remodeling"
                  className="hover:text-brand-orange transition"
                >
                  Kitchen Remodeling
                </Link>
              </li>
              <li>
                <Link
                  to="/bathroom-remodeling"
                  className="hover:text-brand-orange transition"
                >
                  Bathroom Remodeling
                </Link>
              </li>
              <li>
                <Link
                  to="/hard-surfaces"
                  className="hover:text-brand-orange transition"
                >
                  Hard Surfaces
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left">
            <h3 className="font-bold text-lg mb-4">
              Specializing in Hard Surfaces
            </h3>
            <ul className="space-y-2 text-gray-300 flex flex-col items-center md:items-start">
              <li>
                <Link
                  to="/hardwood-floor"
                  className="hover:text-brand-orange transition"
                >
                  Hardwood Floor
                </Link>
              </li>
              <li>
                <Link
                  to="/flagstone"
                  className="hover:text-brand-orange transition"
                >
                  Flagstone
                </Link>
              </li>
              <li>
                <Link
                  to="/pavers"
                  className="hover:text-brand-orange transition"
                >
                  Pavers
                </Link>
              </li>
              <li>
                <Link
                  to="/concrete"
                  className="hover:text-brand-orange transition"
                >
                  Concrete
                </Link>
              </li>
              <li>
                <Link
                  to="/marble-natural-stone"
                  className="hover:text-brand-orange transition"
                >
                  Marble/Natural Stone
                </Link>
              </li>
              <li>
                <Link
                  to="/tile-grout"
                  className="hover:text-brand-orange transition"
                >
                  Tile/Grout
                </Link>
              </li>
            </ul>
          </div>

          <div className="text-center md:text-left">
            <h3 className="font-bold text-lg mb-4">Cities We Serve</h3>
            <ul className="space-y-2 text-gray-300 flex flex-col items-center md:items-start">
              {CITIES.map((city) => (
                <li key={city.slug}>
                  <Link
                    to={`/kitchen-remodeling-${city.slug}`}
                    className="hover:text-brand-orange transition"
                  >
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-center md:text-left">
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-300 text-sm flex flex-col items-center md:items-start">
              <li className="flex items-start gap-2">
                <MapPin
                  size={18}
                  className="mt-1 flex-shrink-0 text-brand-orange"
                />
                <span>220 Walnut Ave., Huntington Beach, CA 92648</span>
              </li>
              <li>
                <a
                  href="tel:9495157800"
                  className="flex items-center gap-2 hover:text-brand-orange transition"
                >
                  <Phone
                    size={18}
                    className="flex-shrink-0 text-brand-orange"
                  />
                  <span>(949) 515-7800</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@specializedservicesinc.com"
                  className="flex items-center gap-2 hover:text-brand-orange transition"
                >
                  <Mail size={18} className="flex-shrink-0 text-brand-orange" />
                  <span>info@specializedservicesinc.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p className="mb-2">
            CA Contractors License #921119 — C-54 / C-15 / B (General Building)
          </p>
          <p>
            &copy; {new Date().getFullYear()} Specialized Services. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
